import React from 'react';

export default function PasswordResetSuccess() {
  return (
    <div style={{ padding: 24, textAlign: 'center' }}>
      <h2>Email sent</h2>
      <p>Please check your email</p>
    </div>
  );
}